// extracted by mini-css-extract-plugin
export default {"container":"system-statistics_container__I90fy","content-container":"system-statistics_content-container__4yicn","inner-tab-container":"system-statistics_inner-tab-container__hXj3b"};